import React, { useEffect, useState } from "react";
import ServiceCard from "./ServiceCard";
import { Col } from "reactstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import weatherImg from "../assets/images/weather.png";
import guideImg from "../assets/images/guide.png";
import customizationImg from "../assets/images/customization.png";

const servicesData = [
  {
    imgUrl: weatherImg,
    title: "Trust",
    desc: "For more than two and a half decades, the travel industry has earned an excellent reputation for reliability. This trustworthiness is something that continues to be upheld even today.",
  },
  {
    imgUrl: guideImg,
    title: "One Stop Solution",
    desc: "Our company offers a complete solution for all your travel requirements. From planning to booking, we provide the most comprehensive services so you can have an enjoyable and stress-free journey.",
  },
  {
    imgUrl: customizationImg,
    title: "Quick Response",
    desc: "Our team is committed to providing prompt responses and being accessible 24/7. We strive to ensure that our clients receive the best possible service at all times.",
  },
  {
    imgUrl: customizationImg,
    title: "Your Safety, Our Priority",
    desc: "We guarantee a safe and secure journey for all of our passengers. We take safety very seriously and never compromise on our standards. You are in the safest hands when travelling with us.",
  },
];

const ServiceList1 = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    updateIsMobile(); // Initial check
    window.addEventListener("resize", updateIsMobile);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable automatic scrolling
  autoplaySpeed: 2000,
    
  };

  return (
    <>
      {isMobile ? (
        <Slider {...settings}>
          {servicesData.map((item, index) => (
            <div key={index} className="mb-4">
              <Col lg="3" md="6" sm="12">
                <ServiceCard item={item} />
              </Col>
            </div>
          ))}
        </Slider>
      ) : (
        <>
          {servicesData.map((item, index) => (
            <Col key={index} lg="3" md="6" sm="12" className="mb-4">
              <ServiceCard item={item} />
            </Col>
          ))}
        </>
      )}
    </>
  );
};

export default ServiceList1;
